import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20with%20deep%20crimson%20and%20soft%20orange%20flowing%20shapes%2C%20modern%20elegant%20atmosphere%2C%20smooth%20curved%20lines%2C%20premium%20brand%20visual%20with%20subtle%20texture&width=1920&height=500&seq=cta-bg-tomato&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-600/90 to-primary-700/90"></div>
      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-white font-heading mb-4">
          准备好开启你的<span className="text-accent-300">精彩视频</span>之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 max-w-[500px] mx-auto">
          加入番茄视频，发现更多有趣的动漫、短视频、搞笑视频和特色节目内容
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/dongman"
            className="px-8 py-3 bg-white text-primary-600 rounded-full text-sm font-bold hover:bg-background-100 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            立即免费观看
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 text-white backdrop-blur-sm rounded-full text-sm font-medium hover:bg-white/25 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}